module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.showModal),
      expression: "$store.state.showModal"
    }],
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span'), _c('span')]), (_vm.$store.state.modalContent === 0) ? _c('div', {
    staticClass: "modal__contact-form"
  }, [_c('ModalContact', {
    attrs: {
      "props": _vm.props.acf.contact
    }
  })], 1) : _vm._e(), (_vm.$store.state.modalContent === 1) ? _c('div', {
    staticClass: "modal__refer-form"
  }, [_c('ModalRefer', {
    attrs: {
      "props": _vm.props.acf.refer
    }
  })], 1) : _vm._e(), (_vm.$store.state.modalContent === 2) ? _c('div', {
    staticClass: "modal__infographic"
  }, [_c('ModalInfographic', {
    attrs: {
      "props": _vm.props.acf.infographic
    }
  })], 1) : _vm._e(), (_vm.$store.state.modalContent === 3) ? _c('div', {
    staticClass: "modal__learn"
  }, [_c('ModalLearn', {
    attrs: {
      "props": _vm.props.acf.learn
    }
  })], 1) : _vm._e(), (_vm.$store.state.modalContent === 4) ? _c('div', {
    staticClass: "modal__survey"
  }, [_c('ModalSurvey', {
    attrs: {
      "props": _vm.props.acf.survey
    }
  })], 1) : _vm._e(), (_vm.$store.state.modalContent === 5) ? _c('div', {
    staticClass: "modal__thank-you"
  }, [_c('ModalThank', {
    attrs: {
      "props": _vm.props.acf.thank
    }
  })], 1) : _vm._e(), (_vm.$store.state.modalContent === 6) ? _c('div', {
    staticClass: "modal__team"
  }, [_c('ModalTeam', {
    attrs: {
      "props": _vm.$store.state.modalProps
    }
  })], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f65043a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal.pug
// module id = 670
// module chunks = 1